import script from "./SearchRouteButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchRouteButton.vue?vue&type=script&setup=true&lang=js"

import "./SearchRouteButton.vue?vue&type=style&index=0&id=2949fed6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2949fed6"]])

export default __exports__